"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var LocaleContext_1 = require("../LocaleContext");
var ArrowButton_1 = require("./ArrowButton");
var Day_1 = require("./Day");
var utils_2 = require("./utils");
var YearsList_1 = require("./YearsList");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: __assign({ width: 280 }, theme.go.mixins.typography.Body),
    header: __assign({ padding: '9px 8px 9px 8px', display: 'flex', justifyContent: 'space-between', color: theme.go.schemes.colors.system.TextMain }, theme.go.mixins.typography.Headline1),
    body: {
        height: 280,
    },
    monthControl: {
        display: 'flex',
        alignItems: 'center',
        textTransform: 'capitalize',
        '& $arrowRight': {
            marginLeft: 4,
        },
    },
    monthStepper: {
        display: 'flex',
        alignItems: 'center',
    },
    tableRow: {
        display: 'flex',
    },
    arrowRight: {
        marginLeft: 8,
    },
    tableHead: __assign(__assign({}, theme.go.mixins.typography.Subhead), { color: theme.go.schemes.colors.system.TextMinor, '& $tableCell': {
            cursor: 'default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: 'none',
        } }),
    tableCell: {
        width: 40,
        height: 40,
        borderBottom: "4px solid ".concat(theme.go.schemes.colors.system.BgMain),
        userSelect: 'none',
    },
}); });
function Calendar(_a) {
    var value = _a.value, selectedRange = _a.selectedRange, onDayClick = _a.onDayClick, classes = _a.classes, isDisabledDate = _a.isDisabledDate;
    var _b = useStyles(), root = _b.root, header = _b.header, monthControl = _b.monthControl, monthStepper = _b.monthStepper, body = _b.body, tableHead = _b.tableHead, tableCell = _b.tableCell, tableRow = _b.tableRow, arrowRight = _b.arrowRight;
    var localeContext = (0, react_1.useContext)(LocaleContext_1.LocaleContext);
    var now = new Date().toISOString();
    var parsedMonth = (0, utils_1.getMonthByDate)(value || now);
    var parsedYear = (0, utils_1.getYearByDate)(value || now);
    var _c = __read((0, react_1.useState)(parsedMonth), 2), month = _c[0], setMonth = _c[1];
    var _d = __read((0, react_1.useState)(parsedYear), 2), year = _d[0], setYear = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), showYears = _e[0], toggleYears = _e[1];
    var days = (0, utils_2.getMonthDays)(month, year);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var weekDays = (0, react_1.useMemo)(function () { return (0, utils_1.getWeakShort)(); }, [localeContext]);
    (0, react_1.useEffect)(function () {
        setMonth(parsedMonth);
    }, [parsedMonth]);
    (0, react_1.useEffect)(function () {
        setYear(parsedYear);
    }, [parsedYear]);
    var incMonth = (0, react_1.useCallback)(function () {
        if (month + 1 < 12) {
            setMonth(month + 1);
        }
        else {
            setMonth(0);
            setYear(year + 1);
        }
    }, [month, setMonth, year, setYear]);
    var decMonth = (0, react_1.useCallback)(function () {
        if (month - 1 >= 0) {
            setMonth(month - 1);
        }
        else {
            setMonth(11);
            setYear(year - 1);
        }
    }, [month, setMonth, year, setYear]);
    var onYearsClick = (0, react_1.useCallback)(function () {
        toggleYears(!showYears);
    }, [showYears, toggleYears]);
    var onYearClick = (0, react_1.useCallback)(function (year) {
        setYear(year);
        toggleYears(false);
    }, [setYear, toggleYears]);
    var dayClasses = (0, react_1.useMemo)(function () { return ({
        root: (0, utils_1.cn)(tableCell, classes === null || classes === void 0 ? void 0 : classes.tableCell),
    }); }, [classes === null || classes === void 0 ? void 0 : classes.tableCell, tableCell]);
    var accuracy = 'day';
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(root, classes === null || classes === void 0 ? void 0 : classes.root) },
        react_1.default.createElement("div", { className: (0, utils_1.cn)(header, classes === null || classes === void 0 ? void 0 : classes.header) },
            react_1.default.createElement("span", { className: (0, utils_1.cn)(monthControl, classes === null || classes === void 0 ? void 0 : classes.monthControl) },
                react_1.default.createElement("span", null, "".concat((0, utils_1.getMonths)()[month], " ").concat(year)),
                react_1.default.createElement(ArrowButton_1.ArrowButton, { direction: showYears ? undefined : 'right', className: (0, utils_1.cn)(arrowRight, classes === null || classes === void 0 ? void 0 : classes.arrowRight), onClick: onYearsClick })),
            react_1.default.createElement("span", { className: (0, utils_1.cn)(monthStepper, classes === null || classes === void 0 ? void 0 : classes.monthStepper) },
                react_1.default.createElement(ArrowButton_1.ArrowButton, { direction: "left", onClick: decMonth }),
                react_1.default.createElement(ArrowButton_1.ArrowButton, { direction: "right", className: (0, utils_1.cn)(arrowRight, classes === null || classes === void 0 ? void 0 : classes.arrowRight), onClick: incMonth }))),
        react_1.default.createElement("div", { className: (0, utils_1.cn)(body, classes === null || classes === void 0 ? void 0 : classes.body) }, showYears ? (react_1.default.createElement(YearsList_1.YearsList, { year: year, onItemClick: onYearClick })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, utils_1.cn)(tableRow, tableHead, classes === null || classes === void 0 ? void 0 : classes.tableRow, classes === null || classes === void 0 ? void 0 : classes.tableHead) }, weekDays.map(function (day) { return (react_1.default.createElement("div", { className: (0, utils_1.cn)(tableCell, classes === null || classes === void 0 ? void 0 : classes.tableCell), key: day }, day)); })),
            days.map(function (week, r) { return (react_1.default.createElement("div", { key: r, className: (0, utils_1.cn)(tableRow, classes === null || classes === void 0 ? void 0 : classes.tableRow) }, week.map(function (dayInfo, c) { return (react_1.default.createElement(Day_1.Day, __assign({ key: "".concat(c, "_").concat(r), firstInRange: !!(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange[0]) &&
                    (0, utils_1.isSame)(dayInfo.date, selectedRange[0], accuracy), lastInRange: !!(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange[1]) &&
                    (0, utils_1.isSame)(dayInfo.date, selectedRange[1], accuracy), inRange: !!selectedRange &&
                    !!(selectedRange[0] || selectedRange[1]) &&
                    (!selectedRange[0] ||
                        (0, utils_1.isAfter)(dayInfo.date, selectedRange[0], accuracy)) &&
                    (!selectedRange[1] ||
                        (0, utils_1.isBefore)(dayInfo.date, selectedRange[1], accuracy)), disabled: isDisabledDate ? isDisabledDate(dayInfo.date) : false }, dayInfo, { classes: dayClasses, onClick: onDayClick, selected: !!value && (0, utils_1.isSame)(dayInfo.date, value, accuracy) }))); }))); }))))));
}
exports.Calendar = Calendar;
